import { render, staticRenderFns } from "./reel-importer.vue?vue&type=template&id=587c9340&"
import script from "./reel-importer.vue?vue&type=script&lang=js&"
export * from "./reel-importer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports